import axios, { AxiosInstance } from "axios";
import {
  getApiResult,
  deleteApiResult,
  postApiResult,
  putApiResult,
} from "@eaigle/api/AxiosWrappers";

export interface Deployment {
  id: string;
  subscriptionName: string;
  avacBackendURL: string;
  cvBackendURL: string;
  agentDashboardURL: string;
  avacDashboardURL: string;
  driversAppURL: string;
  kioskAppURL: string;
}

export interface VersionHistory {
  id: string;
  deploymentId: string;
  product: string;
  changedAt: string;
  lastPoll: string;
  buildDate: string;
  gitCommitHash: string;
  commitDate: string;
  applicationStarted: string;
}

export interface DeploymentVersion {
  subscriptionName: string;
  products: VersionHistory[];
}

const baseURL =
  typeof import.meta.env.VITE_BASE_URL === "string" ? import.meta.env.VITE_BASE_URL : "";
const axiosInstance: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});

const deleteDeployment = (token: string, id: string) =>
  deleteApiResult(axiosInstance, token, `/deployment/${id}`);
const getDeployments = (token: string) =>
  getApiResult<Deployment[]>(axiosInstance, token, "/deployment");
const postDeployment = (token: string, deployment: Deployment) =>
  postApiResult(axiosInstance, token, "/deployment", deployment);
const putDeployment = (token: string, deployment: Deployment) =>
  putApiResult(axiosInstance, token, "/deployment", deployment);

const getHistory = (token: string) =>
  getApiResult<DeploymentVersion[]>(axiosInstance, token, "/history");

export const apiClient = {
  deleteDeployment,
  getDeployments,
  postDeployment,
  putDeployment,
  getHistory,
};
